"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userMessagesDefaultValue = exports.userMessagesSchema = void 0;
const zod_1 = require("zod");
exports.userMessagesSchema = zod_1.z.array(zod_1.z.object({
    title: zod_1.z.string(),
    md: zod_1.z.string(),
    pinned: zod_1.z.boolean(),
    created_at: zod_1.z.string(),
    opts: zod_1.z
        .object({
        minWidth: zod_1.z.string().optional(),
        open: zod_1.z.boolean().optional(),
    })
        .optional(),
}));
const defaultValue = [
    {
        title: 'Título de exemplo',
        md: 'Escreva seu texto',
        pinned: true,
        created_at: '2023-01-01',
        opts: {
            minWidth: '100px',
            open: true,
        },
    },
];
exports.userMessagesDefaultValue = JSON.stringify(defaultValue, null, '\t');
